
<div class="about">
  <div class="about__item">
    <div class="about__item--title">
      Sobre o aplicativo
    </div>
    <div class="about__item--version">
      Version {{ aboutData?.systemVersion }}
    </div>
  </div>

  <div class="about__item">
    <div class="about__item--title">
    Contato Suporte
    </div>
    <div class="about__item--contact" [ngClass]="{
      'three-col': isProvider
    }">
      <div class="contact" *ngIf="isProvider">
        <a target="_blank" [href]="'https://wa.me/'+ aboutData?.supportWhatsapp + '?text=Ol%C3%A1'">
          <svg>
            <use xlink:href="../../../../assets/svg/sprite.svg#icon-whatsapp"></use>
          </svg>{{ aboutData?.supportWhatsapp | formatPhone }}
        </a>
      </div>
      <div class="contact">
        <a target="_blank" [href]="'tel:' + aboutData?.supportPhone">
          <nb-icon icon="phone-outline"></nb-icon><span>{{ aboutData?.supportPhone | formatPhone }}</span>
        </a>
      </div>
      <div class="contact">
        <a target="_blank" [href]="'mailto:' + aboutData?.supportEmail">
          <nb-icon icon="email-outline"></nb-icon>{{ aboutData?.supportEmail }}
        </a>
      </div>
    </div>
  </div>

  <div class="about__item">
    <div class="about__item--title">
      Documentação
    </div>
    <div class="links" [ngClass]="isAdmin || isProvider ? 'two-col': ''" >
      <div class="link">
        <a target="_blank" [href]="aboutData?.documentationURL">Manual</a>
      </div>
      <div class="link" *ngIf="isAdmin || isProvider">
        <a target="_blank" [href]="aboutData?.changelogsURL">Changelog</a>
      </div>
    </div>
  </div>

  <div class="close">
    <button type="button" nbButton ghost (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </div>
</div>